import classNames from 'classnames';
import { Box, Column, Icon, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import './ShiftCard.scss';

export interface IShiftCardProps {
  title: string;
  count: number;
  barColor: string;
  ctaText?: string;
  isClickable: boolean;
  onClick?: () => void;
  countColor?: string;
  isLoading?: boolean;
  showCtaWhenEmpty?: boolean;
  emptyStateMessage?: string;
  dataCy?: string;
  countDataCy?: string;
}

export const ShiftCard = ({
  title,
  count,
  barColor,
  ctaText,
  isClickable,
  onClick,
  countColor,
  isLoading,
  showCtaWhenEmpty = false,
  emptyStateMessage,
  dataCy,
  countDataCy,
}: IShiftCardProps) => {
  const isActive = count > 0 && !isLoading;
  const showBar = isClickable && (isActive || showCtaWhenEmpty);
  const shouldShowCta = isClickable && ctaText && (isActive || showCtaWhenEmpty);
  const showEmptyMessage = !isActive && !isLoading && emptyStateMessage;

  const cardClassName = classNames('shift-card', {
    'shift-card--clickable': isClickable,
    'shift-card--not-clickable': !isClickable,
    'shift-card--active': isActive || shouldShowCta,
  });

  return (
    <div onClick={isClickable ? onClick : undefined} className={cardClassName} data-cy={dataCy}>
      {isLoading ? (
        <div className="shift-card__skeleton">
          <div className="shift-card__skeleton-count" />
          <div className="shift-card__skeleton-title" />
        </div>
      ) : (
        <>
          <Column>
            <Text
              fontSize={46}
              bold
              color={isActive ? countColor || Colors.neutral_600 : Colors.neutral_200}
              lineHeight={1}
              data-cy={countDataCy}
            >
              {count}
            </Text>

            <Text fontSize={22}>{title}</Text>
          </Column>

          {shouldShowCta && (
            <Row alignItems="center" gap={6} justifyContent="flex-end">
              <Box className="shift-card__arrow" marginRight={4}>
                <Icon name="long-arrow-right" color={barColor} />
              </Box>
              <Text fontSize={18} bold>
                {ctaText}
              </Text>
            </Row>
          )}

          {showBar && <div className="shift-card__bar" style={{ backgroundColor: barColor }} />}
          {showEmptyMessage && (
            <div className="shift-card__empty-message" style={{ backgroundColor: barColor }}>
              <Text color={Colors.white}>{emptyStateMessage}</Text>
            </div>
          )}
        </>
      )}
    </div>
  );
};
